module.exports = __webpack_public_path__ + "static/media/jan-avatar.3c7c069b.png";